import { action } from 'satcheljs';
import { ComposeViewState } from 'owa-mail-compose-store';

export default action(
    'updateSIGSDataOnClickAction',
    (composeViewState: ComposeViewState, timeClicked: string, clickIndex: number) => {
        return {
            composeViewState: composeViewState,
            timeClicked: timeClicked,
            clickIndex: clickIndex,
        };
    }
);
